"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo, useCallback } from "react";
import Checkbox from "./Checkbox";
export interface SelectBoxItem {
  id: string;
  label: string;
  value: string;
}
interface SelectBoxProps {
  title: string;
  items: SelectBoxItem[];
  selectedItems?: string[];
  onChange?: (selected: string[]) => void;
  placeholder?: string;
}
export default function SelectBox(t0) {
  const $ = _c(35);
  const {
    title,
    items,
    selectedItems: t1,
    onChange,
    placeholder: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const initialSelected = t3;
  const placeholder = t2 === undefined ? "\u062C\u0633\u062A\u062C\u0648 \u06A9\u0646\u06CC\u062F" : t2;
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedItems, setSelectedItems] = useState(initialSelected);
  let t4;
  if ($[2] !== items || $[3] !== search) {
    let t5;
    if ($[5] !== search) {
      t5 = item => item.label.toLowerCase().includes(search.toLowerCase());
      $[5] = search;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = items.filter(t5);
    $[2] = items;
    $[3] = search;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const filteredItems = t4;
  let t5;
  if ($[7] !== onChange || $[8] !== selectedItems) {
    t5 = value => {
      const newSelected = selectedItems.includes(value) ? selectedItems.filter(v => v !== value) : [...selectedItems, value];
      setSelectedItems(newSelected);
      onChange?.(newSelected);
    };
    $[7] = onChange;
    $[8] = selectedItems;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const toggleItem = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsOpen(_temp);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const toggleOpen = t6;
  let t7;
  if ($[11] !== title) {
    t7 = <span>{title}</span>;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== selectedItems.length) {
    t8 = selectedItems.length > 0 && <span className="bg-primary text-white px-2 py-0.5 rounded text-xs">{selectedItems.length}</span>;
    $[13] = selectedItems.length;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `w-3 h-3 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2" fill="none" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t9) {
    t11 = <svg className={t9} viewBox="0 0 12 7">{t10}</svg>;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <span className="flex items-center gap-1">{t8}{t11}</span>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t7) {
    t13 = <div className="flex justify-between items-center px-3 py-2 cursor-pointer" onClick={toggleOpen}>{t7}{t12}</div>;
    $[21] = t12;
    $[22] = t7;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== filteredItems || $[25] !== isOpen || $[26] !== items || $[27] !== placeholder || $[28] !== search || $[29] !== selectedItems || $[30] !== toggleItem) {
    t14 = isOpen && <div className="w-full bg-transparent rounded-md mt-2 shadow-md p-2"><div className="mb-2"><input type="text" placeholder={placeholder} value={search} onChange={e => setSearch(e.target.value)} className="w-full px-2 py-1 border rounded text-sm" /></div><div className="max-h-60 overflow-y-auto">{filteredItems.map(item_0 => <div key={item_0.id} className="mb-1"><Checkbox label={item_0.label} checked={selectedItems.includes(item_0.value)} onChange={() => toggleItem(item_0.value)} /></div>)}</div>{selectedItems.length > 0 && <div className="mt-2 border-t pt-2"><p className="text-sm mb-1">انتخاب شما:</p><div className="flex flex-wrap gap-1">{selectedItems.map(value_0 => {
            const item_1 = items.find(i => i.value === value_0);
            if (!item_1) {
              return null;
            }
            return <span key={value_0} className="bg-blue-100 text-blue-800 px-2 py-1 rounded flex items-center gap-1 text-xs">{item_1.label}<button onClick={() => toggleItem(value_0)}>×</button></span>;
          })}</div></div>}</div>;
    $[24] = filteredItems;
    $[25] = isOpen;
    $[26] = items;
    $[27] = placeholder;
    $[28] = search;
    $[29] = selectedItems;
    $[30] = toggleItem;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <div className="w-full border rounded-md shadow-sm relative">{t13}{t14}</div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
function _temp(prev) {
  return !prev;
}